window.dataLayer = window.dataLayer || [];

import {
  clickHandler,
  determineActionText,
  queryURL,
} from '@/ui/scripts/analytics/analytics.methods';

const eventName = 'accordion_tracking';
const actionPropTitle = 'accordion_action';
const labelPropTitle = 'accordion_label';

const components = [...document.querySelectorAll('.js-accordion-ga')];
const accordion = {
  accordionTitleClass: '.js-accordion-title-ga',
  itemTitleClass: '.js-accordion-item-title-ga',
  itemClass: '.js-accordion-item-ga',
  itemTriggerClass: '.js-accordion-trigger-ga',
  ctaClass: '.js-accordion-cta-ga',
  open: 'Open',
  close: 'Close',
};

function bindEventListenerAccordion(el, itemTitle, accordionTitle) {
  el.addEventListener('click', (e) =>
    clickHandler(
      {
        event: eventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: `Click - ${accordionTitle ? accordionTitle : 'Project Documents'} - ${itemTitle}`,
        label: activity(el),
      },
      e,
    ),
  );
}

function bindEventListenerAccordionCta(el, accordionTitle) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventName,
      actionProp: actionPropTitle,
      labelProp: labelPropTitle,
      action: `Click - CTA - ${accordionTitle} - ${determineActionText(el)}`,
      label: queryURL(el),
    }),
  );
}

function activity(el) {
  return el.getAttribute('aria-expanded') === 'false' ? accordion.open : accordion.close;
}

function init() {
  if (!components.length) {
    return;
  }

  components.forEach((comp) => {
    const items = [...comp.querySelectorAll(accordion.itemClass)];
    const accordionTitle = comp.querySelector(accordion.accordionTitleClass)?.textContent.trim();
    const accordionCta = comp.querySelector(accordion.ctaClass);

    items.forEach((item) => {
      const itemTitle = item.querySelector(accordion.itemTitleClass)?.textContent.trim();
      const itemTrigger = item.querySelector(accordion.itemTriggerClass);
      bindEventListenerAccordion(itemTrigger, itemTitle, accordionTitle);
    });

    if (accordionCta) {
      bindEventListenerAccordionCta(accordionCta, accordionTitle);
    }
  });
}

export default init;
